import React from 'react';
import {Disclosure, Transition} from "@headlessui/react";
import {concatenate} from "services/string";
import {NavLink, useLocation} from "react-router-dom";
import {ChevronRightIcon} from "../Icon/ngage";

// Type ----

type Link = {
  name: string
  to: string
}

type SidebarNavSubGroupProps = {
  name: string
  links: Array<Link>
}

// Component ----

function SidebarNavSubGroup({links, name}: SidebarNavSubGroupProps) {
  const {pathname} = useLocation();
  const isActive = links.filter(link => link.to === pathname).length > 0

  return (
    <Disclosure as="div" defaultOpen={isActive} className="space-y-1">
      {({open}) => (
        <>
          <Disclosure.Button
            className={concatenate(
              isActive ? 'text-gray-900' : 'text-gray-500 hover:text-gray-600',
              'group w-full flex items-center pl-[2.875rem] pr-1 py-1 text-left text-sm leading-[1.2] font-medium rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-brand'
            )}>
            <div className='flex items-center gap-x-2 w-full'>
              <div className="flex-1">{name}</div>

              <ChevronRightIcon className={concatenate(open && 'rotate-90', 'transition-transform text-gray-400 w-4 h-4')} />
            </div>
          </Disclosure.Button>

          <Transition
            enter="transition transform duration-200 ease-out"
            enterFrom="transform -translate-y-2 opacity-0"
            enterTo="transform translate-y-0 opacity-100"
            leave="transition transform duration-175 ease-out"
            leaveFrom="transform translate-y-0 opacity-100"
            leaveTo="transform -translate-y-2 opacity-0"
          >
            <Disclosure.Panel className="space-y-1">
              {links.map((link) => (
                <NavLink
                  to={link.to}
                  key={link.name}
                  className={({isActive}) => concatenate(
                    isActive ? 'text-gray-800 bg-gray-100 hover:text-gray-900 hover:bg-gray-100' : 'text-gray-500 hover:text-gray-900 hover:bg-gray-100',
                    'group flex items-center ml-[3.4rem] pl-2 pr-2 py-1 text-sm font-normal rounded-md focus:outline-none focus-visible:outline-brand'
                  )}>
                  {link.name}
                </NavLink>
              ))}
            </Disclosure.Panel>
          </Transition>
        </>
      )}
    </Disclosure>
  );
}

// Export ----

export default SidebarNavSubGroup;